import initPipelines from '../init_pipelines';

document.addEventListener('DOMContentLoaded', initPipelines);



// WEBPACK FOOTER //
// ./pages/projects/pipelines/failures/index.js